import axios from 'axios';

export const api = axios.create({
	baseURL: `https://backoffice.autoskolahron.sk`
})

export default api;